import React from 'react';

const Loader = () => (
  <div className="d-flex justify-content-center">
    <div className="spinner-border m-5 loader" role="status" />
  </div>
);

export default Loader;
